export const PROVIDER_KEY = process.env.REACT_APP_ENV + '_VD_PROVIDER';

const _providerLanguage = (provider) => {
  const language = {
    'yoodo': {
      country_code: 'gb',
      code: 'en',
      name: 'EN',
    },
    'indosat': {
      country_code: 'id',
      code: 'id',
      name: 'ID',
    },
    'business': {
      country_code: 'gb',
      code: 'en',
      name: 'EN',
    },
    'business-dashboard': {
      country_code: 'gb',
      code: 'en',
      name: 'EN',
    }
  }
  return language[provider] || 'en';
}
const _providerCurrency = (provider) => {
  const currency = {
    'yoodo': 'MYR',
    'indosat': 'IDR',
    'business': 'USD',
    'business-dashboard': 'USD'
  }
  return currency[provider] || 'USD';
}
const _validateProvider = (provider) => {
  const allowedProviders = ['yoodo', 'indosat', 'business', 'business-dashboard'];

  if( !allowedProviders.includes(provider) ) {
    throw new Error('Invalid provider');
  }

  return provider.toLowerCase();
}
const _providerCountryCode = (provider) => {
  const countryCode = {
    'yoodo': 'MY',
    'indosat': 'ID',
    'business-dashboard': 'ID',
    'business': 'ID',
  }
  return countryCode[provider] || 'MY';
}
const _providerPhonePrefix = (provider) => {
  const phonePrefix = {
    'yoodo': '60',
    'indosat': '62',
    'business': '62',
    'business-dashboard': '62',
  }
  return phonePrefix[provider] || '60';
}

export const setProvider = (provider, config={}) => {
  const providerData = {
    hasProvider: true,
    provider: _validateProvider(provider),
    name: provider,
    countryCode: _providerCountryCode(provider),
    currency: _providerCurrency(provider),
    language: _providerLanguage(provider),
    status: true,
    loginMsgColor: config?.textColor,
    phonePrefix: _providerPhonePrefix(provider),
    config: config
  }

  localStorage.setItem(PROVIDER_KEY, JSON.stringify(providerData));
}

export const getProvider = () => {
  const provider = localStorage.getItem(PROVIDER_KEY);

  if( provider ) {
    return JSON.parse(provider);
  }

  return { hasProvider: false, config: {}, currency: 'MYR', language: 'en', status: false, loginMsgColor: null };
}

export const resetProvider = () => {
  localStorage.removeItem(PROVIDER_KEY);
}

export const getProviderConfigHelper = () => {
    return JSON.parse(localStorage.getItem(process.env.REACT_APP_ENV + '_VD_PROVIDER')) ?? { hasProvider: false, config: {} };
};